import {Injectable} from '@angular/core';
import {NbAuthService} from '@nebular/auth';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {NbToastrService} from '@nebular/theme';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private authService: NbAuthService, private router: Router, private toastrService: NbToastrService) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): Observable<boolean> | Promise<boolean> | boolean {
        return this.authService.isAuthenticatedOrRefresh().pipe(
            tap((authenticated) => {
                const jwt = JSON.parse(localStorage.getItem('auth_app_token'));
                // If JWT is invalid, remove active study and redirect to login page
                if (!authenticated) {
                    localStorage.removeItem('auth_app_token');
                    this.router.navigate(['auth/login']);
                    if (jwt != null) {
                        setTimeout(() => {
                            this.toastrService.warning(
                                'Session has expired and you have been automatically logged out. ' +
                                    'Please log back in.',
                                'Session is expired',
                                {duration: 0},
                            );
                        }, 1500);
                    }
                }
            }),
        );
    }
}
